import { isAndroid, isIOS } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import useLocale from '@/hooks/useLocale';
import useHospitalFlags from '@/hooks/useHospitalFlags';

export function Footer() {
  const { t } = useTranslation();
  const { patientLocale } = useLocale();
  const { hasAppDownload } = useHospitalFlags();

  const { hostname } = window.location;

  let iosLink = 'https://apps.apple.com/ca/app/seamlessmd/id696595041';
  let androidLink =
    'https://play.google.com/store/apps/details?id=md.seamless.app';

  if (hostname.includes('holland')) {
    iosLink = 'https://apps.apple.com/ca/app/myhip-knee/id1005212811';
    androidLink =
      'https://play.google.com/store/apps/details?id=md.myhipknee.app';
  }

  return (
    <footer className="bg-primary-500 -mx-4">
      <div className="max-w-2xl mx-auto text-white py-8">
        {hasAppDownload && (
          <div className="text-center">
            <h3 className="text-lg">{t('common.text.download_mobile')}</h3>
            <div className="flex justify-center my-8">
              {!isIOS && (
                <a href={androidLink} target="_blank" rel="noopener noreferrer">
                  <div className="flex items-center bg-black border w-auto rounded-lg px-4 py-2 w-44 mx-2">
                    <img
                      src="/googleplay.png"
                      className="w-7 md:w-8"
                      alt="google play"
                    />
                    <div className="text-left ml-3">
                      <p className="text-xs text-gray-200 uppercase">
                        Get it on
                      </p>
                      <p className="text-sm md:text-base">Google Play</p>
                    </div>
                  </div>
                </a>
              )}
              {!isAndroid && (
                <a href={iosLink} target="_blank" rel="noopener noreferrer">
                  <div className="flex items-center bg-black border w-auto rounded-lg px-4 py-2 w-44 mx-2">
                    <img
                      src="/appstore.png"
                      className="w-7 md:w-8"
                      alt="app store"
                    />
                    <div className="text-left ml-3">
                      <p className="text-xs text-gray-200">Download on the</p>
                      <p className="text-sm md:text-base"> App Store</p>
                    </div>
                  </div>
                </a>
              )}
            </div>
          </div>
        )}
        <div className="mt-14 flex flex-col md:flex-row md:justify-center items-center text-sm text-gray-200 space-x-4">
          <a
            href={`https://ca.seamless.md/education/241780?lang=${patientLocale}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('common.text.help')}
          </a>
          <a
            href="https://www.seamless.md/eula"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('common.terms_of_use')}
          </a>
          <a
            href="https://www.seamless.md/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('common.privacy_policy')}
          </a>
        </div>
      </div>
    </footer>
  );
}
